import { Injectable } from '@angular/core';

@Injectable()
export class AppDynamicsService {
  appDynamicsKey: string;
  appDynamicsScriptURL: string;
  constructor() {}
}
